import React from 'react'
import facebook from "../Images/Favicons/fb.png"
import github from "../Images/Favicons/github.png"
import instagram from "../Images/Favicons/intsgram.png"
import twitter from "../Images/Favicons/twitter.png"
import Arindam from "../Images/Code Arindam.png"
import "../CSS/Template/Contact.css"
import { Helmet } from 'react-helmet'
import { Typewriter } from "react-simple-typewriter"
import FooTer from "./footer"


export default function Contact(props) {
  let text = Typewriter({
    words: ["Feel Free To Contact Me"],
    loop: 0,
    typeSpeed: 70,
    deleteSpeed: 50,
    delaySpeed: 1000,
    cursor: true,
    cursorStyle: "|"
  })
  return (
    <>
      <Helmet>
        <title>Code Arindam | Contact</title>
      </Helmet>
      <div class="sharethis-sticky-share-buttons" ></div>
      <div id="contact">
        {props.setProgress(0)}
        <h1>{text}</h1>
        <div className="mainContact">
          {props.setProgress(50)}
          <img src={Arindam} alt="loading" id='myLogo' />
          <div className="contactLogos">
            <a className='socialLink' href="https://www.facebook.com/arindam.kumarmondal.1" target="_blank" rel="noreferrer"><img className='socialLogo' src={facebook} alt="loading" /></a>
            <a className='socialLink' href="https://github.com/Arindamk143" target="_blank" rel="noreferrer"><img className='socialLogo' src={github} alt="loading" /></a>
            <a className='socialLink' href="https://www.instagram.com/arindam_kumar_mondal/" target="_blank" rel="noreferrer"><img className='socialLogo' src={instagram} alt="loading" /></a>
            <a className='socialLink' href="https://twitter.com/Code_arindam" target="_blank" rel="noreferrer"><img className='socialLogo' src={twitter} alt="loading" /></a>
            {props.setProgress(100)}
          </div>
        </div>
      </div>
      <FooTer/>
    </>
  )
}
